export { }
declare global {
    export interface Number {
        toPrice(): string;
    }
}
// eslint-disable-next-line no-extend-native
Number.prototype.toPrice = function (this: number) {
    return `${this.toFixed(2)} €`;
};